import { useQuery, useMutation } from "../../api/hooks";

export const useGetNotificationQuery = () => useQuery("api/notification/all");

export const useDeleteNotificationMutation = () =>
  useMutation(null, {
    method: "DELETE",
    buildUrl: (id) => `api/notification/${id}`,
    silent: true,
  });

export const useMarkAllNotificationsReadMutation = () =>
  useMutation("api/notification/mark-all-read", { silent: true });

export const useMarkNotificationReadMutation = () =>
  useMutation(null, {
    buildUrl: (id) => `api/notification/${id}/mark-read`,
    silent: true,
  });
